export var PositionDetailedContent;
(function (PositionDetailedContent) {
    PositionDetailedContent["Forward"] = "forward";
    PositionDetailedContent["BowSide"] = "bow / side";
    PositionDetailedContent["FwdQuarter"] = "fwd quarter";
    PositionDetailedContent["Midships"] = "midships";
    PositionDetailedContent["AftQuarter"] = "aft quarter";
    PositionDetailedContent["AftSide"] = "aft / side";
    PositionDetailedContent["Aft"] = "aft";
})(PositionDetailedContent || (PositionDetailedContent = {}));
//# sourceMappingURL=PositionDetailedContent.js.map